import {
	ABOUT_US_SECTION_ID,
	ABOUT_US_SECTION_NAME,
	CONTACTS_SECTION_ID,
	CONTACTS_SECTION_NAME,
	HOME_SECTION_ID,
	HOME_SECTION_NAME,
	OUR_VALUES_SECTION_ID,
	OUR_VALUES_SECTION_NAME,
	SERVICES_SECTION_ID,
	SERVICES_SECTION_NAME,
	USED_CARS_SECTION_ID,
	USED_CARS_SECTION_NAME,
	WHERE_WE_ARE_SECTION_ID,
	WHERE_WE_ARE_SECTION_NAME,
} from "../../utils/const.js";

/**------------- Menu constants -------------**/

/*  Sections  */
export const ALL_MENU_SECTIONS = [
	{
		id: HOME_SECTION_ID,
		title: HOME_SECTION_NAME,
	},
	{
		id: ABOUT_US_SECTION_ID,
		title: ABOUT_US_SECTION_NAME,
	},
	{
		id: OUR_VALUES_SECTION_ID,
		title: OUR_VALUES_SECTION_NAME,
	},
	{
		id: SERVICES_SECTION_ID,
		title: SERVICES_SECTION_NAME,
	},
	{
		id: USED_CARS_SECTION_ID,
		title: USED_CARS_SECTION_NAME,
	},
	{
		id: WHERE_WE_ARE_SECTION_ID,
		title: WHERE_WE_ARE_SECTION_NAME,
	},
	{
		id: CONTACTS_SECTION_ID,
		title: CONTACTS_SECTION_NAME,
	},
];
